import styles from "../../../styles/LoadingSpinner.module.scss";
import { ImSpinner10 } from "react-icons/im";

const LoadingSpinner = ({ width, height }) => {
  return <div style={{ height: height }} className={styles.spinner}></div>;
};
export default LoadingSpinner;

export const PageLoader = (props) => {
  return (
    <div className={styles.pageLoadingContainer}>
      <div className={styles.spinner}>{props.children}</div>
    </div>
  );
};

// export const ComponentLoader = (props) => {
//   return (
//     <div className="text-center bg-dark p-5">
//       <ImSpinner10 className="h3 icon-spinner" />
//       {props.children}
//     </div>
//   );
// };

export const ComponentLoader = (props) => {
  return (
    <div className={`${styles.componentLoader} text-center rounded p-5 d-flex ${props.className}`}>
      <div className="m-auto">
        <ImSpinner10 className="h3 icon-spinner" />
        {props.children}
      </div>
    </div>
  );
};
